module.exports = [{
      plugin: require('/builds/current-studios/currentstudios-ca/node_modules/gatsby-plugin-emotion/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/builds/current-studios/currentstudios-ca/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"config/typography.js"},
    },{
      plugin: require('/builds/current-studios/currentstudios-ca/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/builds/current-studios/currentstudios-ca/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
